Blocker = require './Blocker'
classnames = require 'classnames'
ConfirmationModal = require '../../../a2i/js/components/ConfirmationModal'
InnerGlyphicon = require './InnerGlyphicon'
ObservationHeader = require './ObservationHeader'
ObserveStudent = require '../containers/ObserveStudent'
React = require 'react'
require '../../styles/ObserveStudents'
require 'moment-duration-format'
TimesUpModal = require './TimesUpModal'
{ Button, Col, Glyphicon, Modal } = require 'react-bootstrap'
{ Component, PropTypes } = React

class ObserveStudentsComponent extends Component
	@propTypes:
		askDone: PropTypes.func.isRequired
		cancelDone: PropTypes.func.isRequired
		confirmingDone: PropTypes.bool.isRequired
		recordStudentObservation: PropTypes.func.isRequired
		currentCycleNumber: PropTypes.number.isRequired
		done: PropTypes.func.isRequired
		getMostRecentStudentObservation: PropTypes.func.isRequired
		gradeLevelId: PropTypes.number.isRequired
		handleUndo: PropTypes.func.isRequired
		isTimerRunning: PropTypes.bool.isRequired
		isTimerUp: PropTypes.bool.isRequired
		navigationWarningModal: PropTypes.node
		numberOfCycles: PropTypes.number.isRequired
		recordStudentEvent: PropTypes.func.isRequired
		setContextToWholeClass: PropTypes.func.isRequired
		# studentMinutes is a moment duration.
		studentMinutes: PropTypes.object.isRequired
		students: PropTypes.arrayOf(PropTypes.object).isRequired
		timer: PropTypes.string.isRequired
		toggleTimer: PropTypes.func.isRequired

	handleEndEarly: =>
		@props.students.map (student) =>
			@props.recordStudentEvent(student.id, 14)

		@props.done()

	render: =>
		React.createElement("div", {"className": "observe-students-container"},
			React.createElement(ObservationHeader, { \
				"confirmDone": ( @props.askDone ),  \
				"currentCycleNumber": ( @props.currentCycleNumber ),  \
				"handleUndo": ( @props.handleUndo ),  \
				"isTimerRunning": ( @props.isTimerRunning ),  \
				"numberOfCycles": ( @props.numberOfCycles ),  \
				"timer": ( @props.timer ),  \
				"toggleTimer": ( @props.toggleTimer ),  \
				"totalTime": ( @props.studentMinutes.format('hh:mm:ss', trim: false) )
			}),

			React.createElement("div", {"className": "observe-students"},
				(
					@props.students.asMutable({ deep: true }).map (student, index) =>
						React.createElement(ObserveStudent, { \
							"cycleNumber": ( @props.currentCycleNumber ),  \
							"getMostRecentStudentObservation": ( @props.getMostRecentStudentObservation ),  \
							"gradeLevelId": ( @props.gradeLevelId ),  \
							"key": ( 'observe-student-' + index ),  \
							"recordStudentEvent": ( @props.recordStudentEvent ),  \
							"recordStudentObservation": ( @props.recordStudentObservation ),  \
							"setContextToWholeClass": ( @props.setContextToWholeClass ),  \
							"student": ( student ),  \
							"timer": ( @props.timer )
						})
				),
				React.createElement(Blocker, {"shouldShow": ( !@props.isTimerRunning )})
			),
			React.createElement(ConfirmationModal, { \
				"body": "Are you sure you're done with this observation?",  \
				"confirmationButtonStyle": "warning",  \
				"confirmationButtonText": "Yes, done",  \
				"onCancel": ( @props.cancelDone ),  \
				"onConfirm": ( @handleEndEarly ),  \
				"shouldShow": ( @props.confirmingDone ),  \
				"title": "Really done?"
			}),
			React.createElement(TimesUpModal, {"onClose": ( @props.done ), "shouldShow": ( @props.isTimerUp )}),
			( @props.navigationWarningModal )
		)

module.exports = ObserveStudentsComponent



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/components/ObserveStudents.cjsx